import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import WithRender from '@/Pages/Admin/Modules/ManageUsers/Profile/Views/individual-profile.html';
import {common} from '@/Pages/Admin/Modules/Common/Services/Common';
import ValidationError from '@/Pages/Admin/Modules/Common/Controllers/ValidationError';
import {trekService} from '@/Pages/Admin/Modules/ManagePackage/Services/Trekservice';
import {flashService} from '@/Pages/Admin/Modules/Common/Services/FlashMessage/FlashService';
import {AccountUserProfileModel} from '@/Pages/Admin/Modules/Models/ManageAccount/AccountUserProfileModel';
import {trekapi} from '@/Pages/Admin/Modules/ManagePackage/Services/Trekapi';
import UploadFile from '@/Pages/Admin/Modules/Common/Controllers/UploadAny';
import {UserModel} from '@/Pages/Admin/Modules/Models/ManageAccount/UserModel';


@WithRender
@Component({
    components: {
        UploadFile,
        'validation-error': ValidationError,
    }
})
export default class IndividualProfile extends Vue {
    protected ui: any = {};
    protected item: any = {};
    protected vars: any = {};

    constructor() {
        super();

        this.ui = {
            status: {
                isLoading: {
                    getUserProfile: false,
                },
                postLoading: {
                    editProfile: false,
                },
                editProfile: false,
                fileupload: false,
                checkTitle: false,
            },
            error: {
                errors: {},
                has_error: false,
                error_message: {},
            },
        };

        this.item = {
            activeUser: {},
            userData: new UserModel({}),
            tempUserData: new UserModel({}),
            profileData: new AccountUserProfileModel({}),
            tempProfileData: new AccountUserProfileModel({}),
        };

        this.vars = {
            titles: {
                btn_title: 'Upload Image',
                modal_title: 'Upload Image',
                browse_title: 'Browse Image File',
                document_title: 'Title or description for the Upload Image',
            },
            limitdata: {
                extensions: 'jpg|jpeg|bmp|png',
                maxSizeInMB: '5',
                fileType: '',
                invalidSizeMsg: 'Exceeded maximum File Upload  size 1 MB',
                invalidFileTypeMsg: 'Only Jpeg, png files are supported',
                titleRequiredMsg: 'Title field is required.',
            },
            postdata: {
                post_url: '',
            },
        };
    }

    public created() {
        this.getUserProfile();
        this.item.activeUser = common.CurrentLoggedBusinessUser()
            ? common.CurrentLoggedBusinessUser()
            : '';
    }

    public getUserProfile() {
        this.ui.status.isLoading.getUserProfile = true;
        trekService
            .retrieveUserProfile()
            .then((res: any) => {
                this.item.profileData = res.data.data;
                this.item.userData = res.data.data.length > 0 ? res.data.data.account_user.user : this.item.activeUser;
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.error_message).then(res => {
                    this.ui.error.error_message = res;
                });
            })
            .finally(() => {
                this.ui.status.isLoading.getUserProfile = false;
            });
    }

    protected onEditProfileClick() {
        this.ui.status.editProfile = true;
        this.item.tempUserData = Object.assign({}, this.item.userData);
        this.item.tempProfileData = Object.assign({}, this.item.profileData);

    }


    protected preventNonNumericalInput(event: any) {
        common.preventNonNumericalInput(event);
    }

    protected onCancelProfileClick() {
        this.resetError();
        this.ui.status.editProfile = false;
        this.item.userData = this.item.tempUserData;
        this.item.profileData = this.item.tempProfileData;
    }

    protected updateProfile() {
        this.resetError();

        if (!this.validateUpdateProfileAction()) {
            return;
        }
        let data = {
            firstname: this.item.activeUser.firstname,
            lastname: this.item.activeUser.lastname,
            address_line1: this.item.profileData.address_line1,
            address_line2: this.item.profileData.address_line2,
            city: this.item.profileData.city,
            province: this.item.profileData.province,
            country: this.item.profileData.country,
            zip: this.item.profileData.zip,
            mobile1: this.item.profileData.mobile1,
            mobile2: this.item.profileData.mobile2,
            contact_person: this.item.profileData.contact_person,
            contact_person_mobile: this.item.profileData.contact_person_mobile,
        };
        this.ui.status.postLoading.editProfile = true;
        trekService
            .updateProfileDetail(data)
            .then((res: any) => {
                this.item.profileData = res.data.data;
                flashService.Success('Profile Updated', res.data.message);
                this.ui.status.postLoading.editProfile = false;
                this.ui.status.editProfile = false;
                this.resetError();
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.error_message).then(res => {
                    this.ui.error.error_message = res;
                });
            })
            .finally(() => {
                this.ui.status.postLoading.editProfile = false;
            });
    }

    protected validateUpdateProfileAction() {
        let row = this.item.profileData;
        if (!this.item.activeUser.firstname) {
            Object.assign(this.ui.error.errors, {
                first_name: ['The first name field is required.'],
            });
        }
        if (this.item.activeUser.firstname) {
            if (this.item.activeUser.firstname.match(/^[a-z]+$/i) === null) {
                Object.assign(this.ui.error.errors, {first_name: ['Please enter valid first name.']});
            }
        }
        if (!this.item.activeUser.lastname) {
            Object.assign(this.ui.error.errors, {
                last_name: ['The last name field is required.'],
            });
        }
        if (this.item.activeUser.lastname) {
            if (this.item.activeUser.lastname.match(/^[a-z]+$/i) === null) {
                Object.assign(this.ui.error.errors, {last_name: ['Please enter valid last name.']});
            }
        }
        if (row.country) {
            if (row.country.match(/^[a-z]+$/i) === null) {
                Object.assign(this.ui.error.errors, {country_name: ['Please enter valid country name.']});
            }
        }

        if (common.notEmpty(this.ui.error.errors)) {
            this.ui.error.has_error = true;
            return false;
        } else {
            return true;
        }
    }

    public resetError() {
        this.ui.error.errors = {};
        this.ui.error.has_error = false;
        this.ui.error.error_message = {};
    }

    protected onUploadProfileImage(uploadType: string) {
        this.vars.postdata.post_url = trekapi.updateProfileImage();
        this.vars.postdata.uploadType = uploadType;
        if (uploadType === 'image') {
            this.vars.titles.btn_title = 'Upload Image';
            this.vars.titles.browse_title = 'Browse Image';
            this.vars.titles.modal_title = 'Upload Profile Image';
        }
        this.ui.status.fileupload = true;
        // this.vars.postdata.id = this.$route.query.id;
    }

    // Image upload Section
    protected documentUploaded(data: any) {
        if (data.file_type === 'image/png' || 'image/jpeg' || 'image/jpg') {
            this.item.profileData = data;
            flashService.Success('Image Uploaded', 'Image Successfully Added.');
        }
    }

    protected async closeUploadModal() {
        this.ui.status.fileupload = false;
    }

}
